// extracted by mini-css-extract-plugin
export default {"arrowButton":"ArrowButton_arrowButton__peY0U","arrow":"ArrowButton_arrow__vshKA","left":"ArrowButton_left__BFfG-","right":"ArrowButton_right__ds1Fo"};